import { makeStyles } from '@material-ui/styles';

const MOBILE_RESULT_BAR_HEIGHT = 115;

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
  },
  content: {
    padding: [0, theme.spacing(4)],
    height: `calc(100% - ${MOBILE_RESULT_BAR_HEIGHT}px)`,
    overflow: 'scroll',
    paddingBottom: 100,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [theme.breakpoints.up('mobile')]: {
      padding: [0, theme.spacing(6), theme.spacing(6), theme.spacing(4)],
      height: 'unset',
      overflow: 'unset',
    },
  },
  mobileResultsBar: {
    height: MOBILE_RESULT_BAR_HEIGHT,
    positin: 'absolute',
    top: 0,
  },
  headerText: {
    marginTop: theme.spacing(4),
    fontSize: 20,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 32,
    },
  },
  input: {
    marginTop: theme.spacing(0),
  },
  inputHeader: {
    marginBottom: theme.spacing(0),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/useStyles.js